import { render, staticRenderFns } from "./CommentsActivityTabs.vue?vue&type=template&id=149e4e4b&"
import script from "./CommentsActivityTabs.vue?vue&type=script&lang=js&"
export * from "./CommentsActivityTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports